import { CaseStatusFilter, StatusTypes } from './caseApplications';
import { CaseType, StatusCaseItem, Category } from './caseTypes';
import { ActionStatus, ClientSegmentType } from './clientDirectory';
import { Pagination } from './common';
import { State } from './countries';

export type PhaseNameCaseLabel = 'Phase 2: Applicant Intake';

export type CasesTabName = 'my-cases' | 'archived';

export type PhaseNameCase =
	| 'Investigation'
	| 'Investigation Phase'
	| 'Applicant Intake'
	| 'Applicant Intake Phase'
	| 'Active Case Phase'
	| 'Active Case'
	| 'Settlement Phase'
	| 'Settlement'
	| 'Notes';

export type PhaseName =
	| 'Investigation'
	| 'Applicant Intake'
	| 'Active Case'
	| 'Settlement'
	| 'Case closed';

export type StepNameCase =
	| 'Case Details'
	| 'Landing Page Case Details'
	| 'Landing Page Case Claim Form'
	| 'Documents Requested (Optional)'
	// | 'Documents Required'
	| 'Retainer'
	| 'Documents to Send'
	| 'Demand Letter'
	| 'Complaint'
	| 'Opt Out Request'
	| 'Settlement Details'
	| 'Payment Details';

export type StatusColorCase = 'gray' | 'green' | 'red' | 'check' | 'x';

export type DocumentType =
	| 'Opt'
	| 'Demand Letter'
	| 'Complaint'
	| 'Settlement Agreement';

export enum PaymentMethodEnum {
	GROUP = 'GROUP',
	INDIVIDUAL = 'INDIVIDUAL',
	EXTERNAL = 'EXTERNAL',
}
export interface ListCasesRequest {
	search?: string | null;
	limit?: number | null;
	phase?: string | null;
	status?: string | null;
	alphabetical?: boolean;
	page: string;
	archived?: boolean;
}

export interface BrandData {
	brandId: string;
	entityType: string;
	defendantIncorporation: number;
	princpialPlaceOfBusiness: number;
}

export interface CreateCase {
	caseId: string;
	caseName: string;
	caseType: string;
	statusId: number | null;
	categoryId: number | null;
	elegibleStateIds: number[];
	brandsData: BrandData[];
	lawyerIds: string[];
}

export interface ListCasesLawyerResponse {
	items: CaseLawyerItem[];
	total: number;
	page: number;
	limit: number;
	totalItems: number;
	totalPages: number;
}

export interface CaseLawyerItem {
	id: string;
	title: string;
	is_draft: boolean;
	is_pinned: boolean;
	lawyer_tasks: number;
	case_status: CaseStatusFilter;
	case_status_color: StatusColorCase;
	progress_name: CaseStatusFilter;
	created_at: string;
	total_clients: number;
	total_messages: number;
	status: StatusCaseItem | null;
	visible: boolean;
}

export interface CasePhases {
	id: number;
	name: PhaseName;
}

export interface CaseLawyerStatus {
	id: number;
	name: CaseStatusFilter;
}

export interface CaseDetailsLawyer {
	ads_data: {
		hasCampaign: boolean;
		total_ad_expenses: number;
	};
	about_company: string | null;
	about_claim: string | null;
	id: string;
	advertising_spent: number;
	applicants_target_goal: number;
	brand_id: string | null;
	title: string;
	case_type: CaseType | null;
	category_id: number;
	eligibility_criteria: string | null;
	status_id: number | null;
	is_draft: boolean;
	is_document_required: boolean | null;
	registration_deadline: string | null;
	cover_image: string | null;
	thumbnail_image: string | null;
	defendant_id: number;
	principal_place_id: number;
	entity_type: string | null;
	created_at: string;
	updated_at: string;
	phase_name: PhaseNameCase;
	progress_name: StatusTypes;
	lawyers: Lawyer[] | null;
	states: State[];
	category: CategoryCaseLawyer | null;
	status: StatusCaseLawyer | null;
	principal_place_of_business: GenericData | null;
	defendant_incorporation: GenericData | null;
	date_settlement_sent: string | null;
	date_payment_sent: string | null;
	date_case_resolved: string | null;
	intake_status_changed_at: string | null;
	is_pinned: boolean;
	brands: Brand[];
	number_of_client: number;
	brand: {
		id: string;
		name: string;
		logo: string;
	} | null;
}
export interface Brand {
	id: string;
	name: string;
	defendant_incorporation: {
		id: number;
		name: string;
	};
	principal_place_of_business: {
		id: number;
		name: string;
	};
	entity_type: string;
	caseBrandId: number;
	created_at: string;
}
export interface CategoryCaseLawyer {
	id: number;
	name: Category;
	created_at: string;
	updated_at: string;
}

export interface StatusCaseLawyer {
	id: number;
	name: StatusCaseItem;
	created_at: string;
	updated_at: string;
}

export interface Lawyer {
	id: string;
	username: string;
	profile_picture: string | null;
	is_own?: boolean;
}

export interface GenericData {
	id: number;
	name: string;
	created_at: string;
	updated_at: string;
}

// export interface State {
// 	id: number;
// 	name: string;
// }

export interface CaseMetricsData {
	clientsResult: ClientsResult[];
	ClientTargetResult: ClientTargetResult[];
	ActionRequiredResult: ActionRequiredResult[];
	AdvertisingROIResult: AdvertisingRoiresult[];
	ClientAcquisitionFunnelResult: ClientAcquisitionFunnelResult[];
	ClientSegmentationResult: ClientSegmentationResult[];
}

export interface ClientsResult {
	total_on_hold: number;
	total_in_progress_or_action_required: number;
	total_declined_opt_forms: number;
}

export interface ClientTargetResult {
	target_goal: number;
	eligible_clients_to_date: number;
	percentage_of_target_met: number;
}

export interface ActionRequiredResult {
	action_required_lawyer: number;
	action_required_client: number;
	new_emails: number;
}

export interface AdvertisingRoiresult {
	cost_per_acquisition: number;
	conversion_rate: number;
}

export interface ClientAcquisitionFunnelResult {
	case_title: string;
	claim_submission: number;
	preliminary_auto_approval: number;
	client_documentation_received: number;
	claim_approved: number;
	signed_retainer: number;
}

export interface ClientSegmentationResult {
	segmentation_name: ClientSegmentType;
	users_in_segment: number;
	percentage: number;
}

export interface ActionRequiredLawyerData extends Pagination {
	items: ActionRequiredLawyer[];
}

export interface ActionRequiredLawyer {
	id: string;
	firstname: string;
	lastname: string;
	profile_picture: string | null;
	action_type: string;
	client_task_end_date: string;
	application_id: number;
	status_color: ActionStatus;
	case_id: string;
	title: string;
}

export interface NotesResponse {
	items: NoteItem[];
	totalItems: number;
	page: number;
	limit: number;
	totalPages: number;
}

export interface NoteItem {
	id: number;
	comment: string;
	createdAt: string;
	user: UserNote;
}

export interface UserNote {
	firstname: string;
	lastname: string;
	profile_picture: string | null;
}

export interface DocumentActivePhase {
	updated_at: string | number | Date;
	id: number;
	case_id: string;
	document_type: DocumentType;
	document_name: string;
	file_path: string;
	created_at: string;
	sent_at: string | null;
}

export interface DocumentRecordData {
	id: string;
	file_name: string;
	total_clients: number;
	document_url: string;
	case_id: string;
	case_type: CaseType;
	created_at: string;
}

export interface DocumentRecordPayload {
	documentType: 'Demand Letter' | 'Complaint';
	documentName: string;
	documentUrl: string;
	is_all_users: boolean;
}

export interface VersionRecordData {
	id: string;
	name: string;
	total_users: number;
	case_id: string;
	case_type: CaseType;
	created_at: string;
}

export interface OPTHistoryData {
	id: string;
	document_name: string;
	document_url: string;
	active_users: number;
	is_sent: boolean;
	case_id: string;
	created_at: string;
}

export type SettlementType = 'No_Signature_Required' | 'Signature_Required';
export interface CaseSettlementDetails {
	total_amount: number;
	attorney_fees: number;
	type_of_settlement: SettlementType | null;
	date_of_settlement: null;
	date_settlement_sent: string | null;
	attorney_expenses: number;
	settlement_agreement: string | null;
	payment_method: PaymentMethodEnum;
	group_amount: number;
}

export interface UsersToPay {
	items: UserToPayItem[];
	total: number;
	page: number;
	limit: number;
	totalItems: number;
	totalPages: number;
}

export interface UserToPayItem {
	application_id: number;
	amount: number | null;
	user_firstname: string;
	user_lastname: string;
	user_profile_picture: string | null;
	state_name: string;
	payment_status: 'PENDING' | 'SUCCESS' | 'FAILED';
	formattedAmount?: string;
	error?: null | {
		message: string;
	};
}

export interface PaymentDistribution {
	payment_method: PaymentMethodEnum;
	amount: number;
	// user_payments: UserToPayItem[];
}

export interface SaveCaseSettlement {
	total_amount: number;
	attorney_fees: number;
	type_of_settlement?: string;
	date_of_settlement: string;
	attorney_expenses: number;
	file: File | undefined;
}

export interface CaseSettlementUsersSign {
	items: [];
	total: number;
	page: number;
	limit: number;
	totalItems: number;
	totalPages: number;
}

export interface SettlementSummary {
	total_customers: number;
	payment_method: PaymentMethodEnum;
	settlement_amount: number;
	per_plaintiff_total: number;
}

export interface PaymentSummary {
	paid_count: number;
	pending_count: number;
	last_payment_date: string | null;
}
export interface UsersSignItem {
	name: string;
	signature: string;
	date: string;
}
export interface ClaimFormUser {
	caseId: string;
	applicationId: number;
	questions: QuestionClaim[];
	responses: Response[];
}

export interface QuestionClaim {
	id: number;
	question: string;
	question_type: string;
	multiple_choise_questions: QuestionMultipleChoiseQuestion[];
}

export interface QuestionMultipleChoiseQuestion {
	id: number;
	brand: string;
	complement: string;
}

export interface Response {
	question_id: number;
	answer: string;
	multiple_choise_questions: ResponseMultipleChoiseQuestion[];
}

export interface ResponseMultipleChoiseQuestion {
	multiple_id: number;
	answer: boolean;
}
